// extracted by mini-css-extract-plugin
export default {"draftReportHeader":"DraftReportHeader_draftReportHeader__V5+pj","headerCrumbs":"DraftReportHeader_headerCrumbs__OEN1P"};